import { createContentPropTypes } from '../../helpers/content';

const content = {
	fraudTitle: 'Protect yourself from fraud and scams',
	fraudIntroMultiple: [
		'Your bank and other trusted organisations will never ask you to move your money - but scammers will.',
		'So before you add any payees and send your money, take some time to stop and think:',
	],
	fraudIntroSingle: [
		'Your bank and other trusted organisations will never ask you to move your money - but scammers will.',
		'So before you add this payee and send your money, take some time to stop and think:',
	],
	fraudQuestions: [
		"Is someone you don't know pressurising you to make this payment?",
		'Have you been contacted by someone requesting you to move or transfer money to another account?',
	],
	fraudRecoveryMultiple:
		"If you make a payment to these payees and it turns out to be a scam, it's unlikely your money will be recovered. So if you're not sure, don't risk it.",
	fraudRecoverySingle:
		"If you make a payment to this payee and it turns out to be a scam, it's unlikely your money will be recovered. So if you're not sure, don't risk it.",
	fraudMoreInformationBeforeLink: 'For more information, visit the ',
	fraudMoreInformationAfterLink: ' on our website',
	fraudMoreInformationLinkName: 'security section',
	fraudConfirmMultiple:
		"By ticking this box you confirm you're happy to add these payees and proceed with payments to them.",
	fraudConfirmSingle:
		"By ticking this box you confirm you're happy to add this payee and proceed with payments to them.",
	fraudErrorMessage: "Please tick the box if you've reviewed the warning and are happy to proceed.",
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
